export const calcSecsWithRemainingMs = (timeMs: number) => {
    const timeSecsFloat = timeMs / 1000;
    const timeSecs = parseInt(String(timeSecsFloat), 10);
    const remainingMs = timeMs - timeSecs * 1000;
    return { timeSecs, remainingMs };
};
